Vue.component('medalAdmin', {
  template: templates.medalAdmin,
  data() {
    return {
      model: {
        medals: {},
        allMedals: {},
        medalId: null,
        searchResults: [],
        hasResults: false,
        error: 'No medals loaded.'
      }
    }
  },
  mounted() {
    const c = this;
    c.$root.$on('getMedals', medals => {
      c.model.allMedals = medals;
    });
  },
  methods: {
    searchUsers() {
      const c = this;
      let names = [];
      const twitchDisplayName = $('[name="medal-user"]').val();

      userService.search({twitchDisplayName: twitchDisplayName})
        .then(function (response) {
          c.model.searchResults = response.data;
          for (let data of response.data) {
            names.push(data.twitchDisplayName);
          }
          
          $('[name="medal-user"]').autocomplete({
            source: names
          });
        })
        .catch(function (error) {
        
        });
    },
    getUserId(twitchDisplayName, callback) {
      const c = this;
      for (let user of c.model.searchResults) {
        if (user.twitchDisplayName == twitchDisplayName) {
          callback(user.twitchId);
          return;
        }
      }

      twitchAPI.getUserByLogin(twitchDisplayName, function(userData) {

        for (let data of userData) {
          callback(data.id);
          return;
        }
        
        callback(null);

      });
    },
    get() {
      const c = this;
      const twitchDisplayName = $('[name="medal-user"]').val();

      c.getUserId(twitchDisplayName, function(twitchId) {

        if (!twitchId) {
          utils.alert.error('Invalid user');
          return;
        }

        medalService.getMedals({twitchId: twitchId})
          .then(function (response) {
            for (let data of response.data) {
              data.deleted = false;
              c.model.medals[data.id] = data;
            }
            c.model.hasResults = true;
            //c.model.medals = response.data;
          })
          .catch(function (error) {
            c.model.error = 'This user has no achievements';
          });

      });
    },
    add() {
      const c = this;
      const twitchDisplayName = $('[name="medal-user"]').val();

      c.getUserId(twitchDisplayName, function(twitchId) {

        if (!twitchId || !c.model.medalId) {
          utils.alert.error('User and medal required!');
          return;
        }

        medalService.saveMedal({medalId: c.model.medalId, twitchId: twitchId})
          .then(function (response) {
            c.reset();
            utils.alert.success('Medal Added!');
          
          })
          .catch(function (error) {
            utils.alert.error('Failed to save.');
          });

      });
    },
    remove(id) {
      const c = this;
      let error = 'This user has no achievements';

      c.model.hasResults = false;

      var result = confirm("Are you sure you want to remove this medal?");
      if (result == true) {
        medalService.deleteMedal({id: id})
          .then(function (response) {
            delete c.model.medals[id];

            if (Object.keys(c.model.medals).length == 0) {
              c.model.error = error;
            } else {
              c.model.hasResults = true;
            }
          })
          .catch(function (error) {
            c.model.error = error;
          });
      }
    },
    reset() {
      const c = this;
      $('[name="medal-user"]').val('');
      c.model.medalId = null;
      c.model.medals = {};
      c.model.hasResults = false
    }
  }
});